
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <b>Peter S., 83, verstorben am 7. April 2020</b>
    <br />
    <br />
    <i>Sein Sohn Andreas S. sagt: </i>
    <br />
    <p>
  «Zum letzten Mal gesehen habe ich meinen Vater an meinem Geburtstag im Januar.
  Da besuchte ich ihn mit meiner Frau und den Kindern im Altersheim in der Nähe
  von Lugano, wo er lebte. Wir wussten nicht, dass es unser letztes
  Beisammensein sein würde.
    </p>
    <p>
  Ein Jahr zuvor hatte er zwar eine schwere Lungenentzündung erlitten. Ich fuhr
  damals sofort ins Tessin, um Abschied von ihm zu nehmen, doch wie durch ein
  Wunder erholte er sich gut. Dann kam das Virus.
    </p>
    <p>
  Ab dem 10. März waren die Tessiner Altersheime für Besucher geschlossen. Ab
  dem 25. März hätten wir per Videochat mit meinem Vater reden können, doch da
  war er bereits erkrankt. Wie viele andere Bewohner des Heims. Ein Gespräch war
  nicht mehr möglich.
    </p>
    <p>
  Seine Hausärztin fragte, ob wir das Medikament Hydroxychloroquin ausprobieren
  wollten. Doch leider brachte es nichts. Wir entschieden uns gegen eine
  Einweisung ins Spital. Er selber konnte sich nicht mehr äussern. Wegen der
  Schmerzmittel war er nur noch reduziert ansprechbar. Ich bin aber sicher, er
  hätte gleich entschieden: Er war ein Fatalist.
    </p>
    <p>
  Er hatte ein gutes Leben, für ihn war es überhaupt nicht zu kurz. Er war
  bereit zu gehen. Das macht das Abschiednehmen für uns leichter. Was ebenfalls
  hilft, ist der Gedanke, dass so viele Menschen am Virus gestorben sind. Es ist
  wie eine Naturkatastrophe. Wir Hinterbliebenen sind Teil einer Gemeinschaft.
    </p>
    <p>
  Schwierig war hingegen, dass wir meinen Vater nicht beerdigen konnten, seine
  beiden Schwestern leben in Deutschland und sind ebenfalls gefährdet. So steht
  seine Urne bis heute bei uns im Wohnzimmer. Als sie im April eingeschrieben
  mit der Post geliefert wurde, sagte meine fünfjährige Tochter: ‹Opa ist schon
  ein bisschen klein.› Jetzt lebt mein Vater mit uns, bis wir ihn beerdigen
  können. Das ist schön.»
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;